package org.example.zone360.pages.coachDetails.coachPlayerList

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.stevdza.san.kotlinbs.components.BSTooltip
import com.stevdza.san.kotlinbs.components.initializeTooltips
import com.stevdza.san.kotlinbs.models.TooltipDirection
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WordBreak
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaInfo
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.example.zone360.utils.getSessionSummary
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CustomPagination
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.components.StarRating
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetPlayerData
import org.example.zone360.models.GetSessionSummaryData
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Divider
import org.example.zone360.utils.Res
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun CoachPlayerRow(
    sitePalette: SitePalette,
    breakpoint: Breakpoint,
    playerList: List<GetPlayerData>,
    isLoadingState: Boolean
){
    val isLoading by remember { mutableStateOf(isLoadingState) }
    var isViewClicked by remember { mutableStateOf(false) }
    val scope = rememberCoroutineScope()
    var userId by remember { mutableStateOf("") }
    val selectedPlayer by remember { mutableStateOf(GetPlayerData()) }
    val ctx = rememberPageContext()
    var isExpanding by remember { mutableStateOf(false) }
    val sessionSummary = remember { mutableStateListOf<GetSessionSummaryData>() }
    var isSummaryLoading by remember { mutableStateOf(false) }
    var isSentLoading by remember { mutableStateOf(false) }


    if (isViewClicked){
        CoachPlayerRecommendationPopup(
            onDialogDismiss = { isViewClicked = false },
            breakpoint = breakpoint,
            modalNumber = 4,
            userId = userId,
            data = selectedPlayer
        )
    }
    if (isLoading) {
        Box (modifier = Modifier.fillMaxWidth()
            .height(400.px),
            contentAlignment = Alignment.Center){
            ProgressIndicator()
        }
    } else {
        if (playerList.isEmpty()) {
            Box(
                modifier = Modifier.fillMaxWidth()
                    .height(400.px),
                contentAlignment = Alignment.Center
            ) {
                FieldTitleTextNormalSimple(
                    "No player is added in your team(s)"
                )
            }
        } else {
            if (breakpoint >= Breakpoint.MD){
            playerList.sortedByDescending { it.rating }.forEach { player ->
                key(player.userId) {
                    val selectedRating by remember { mutableStateOf(player.rating) }
                    Row(
                        modifier = Modifier.fillMaxWidth()
                            .margin(topBottom = 10.px),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        Row(
                            modifier = Modifier.width(150.px)
                                .onClick {
                                    ctx.router.navigateTo("/player-details?userId=${player.userId}")
                                }
                                .cursor(Cursor.Pointer),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            if (player.imageUrl.isNotEmpty()) {
                                Image(
                                    src = "${Res.Images.base_Image_Url}${player.imageUrl}",
                                    modifier = Modifier.size(30.px).margin(right = 5.px)
                                        .borderRadius(100.px).textAlign(TextAlign.Start)
                                )
                            } else {
                                Image(
                                    src = Res.Images.userIcon,
                                    modifier = Modifier.size(30.px).margin(right = 7.px)
                                        .borderRadius(100.px)
                                )
                            }
                            Column {
                                FieldTitleTextNormalSimple(
                                    text = "${player.firstName} ${player.lastName}"
                                        .split(" ")
                                        .joinToString(" ") { word ->
                                            word.lowercase().replaceFirstChar { it.titlecase() }
                                        },
                                    wordBreak = WordBreak.BreakAll,
                                    isClickable = true
                                )
                                FieldTitleTextNormalSimple(
                                    text = player.team.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() },
                                    fontSize = 11.px,
                                    color = sitePalette.infoIconColor.rgb,
                                    wordBreak = WordBreak.BreakAll,
                                    isClickable = true

                                )
                            }
                        }
                        FieldTitleTextNormalSimple(
                            text = player.position.ifEmpty { "-" },
                            width = 150.px,
                            wordBreak = WordBreak.BreakAll,
                            textAlign = TextAlign.Center
                        )
                        FieldTitleTextNormalSimple(
                            text = player.age.ifEmpty { "-" },
                            width = 90.px,
                            wordBreak = WordBreak.BreakAll,
                            textAlign = TextAlign.Center
                        )
                        FieldTitleTextNormalSimple(
                            text = if (player.count.toInt() == 0) "-" else player.count.toString(),
                            width = 90.px,
                            wordBreak = WordBreak.BreakAll,
                            textAlign = TextAlign.Center
                        )

                        Box(
                            modifier = Modifier.width(200.px),
                            contentAlignment = Alignment.Center
                        ) {
                            StarRating(
                                rating = selectedRating,
                                cursor = false,
                                onRatingChanged = {
                                }
                            )
                        }

                        Box(
                            modifier = Modifier.width(120.px),
                            contentAlignment = Alignment.Center
                        ) {
                            CommonButton(
                                text = "View",
                                textSpanColor = if (player.count > 0) sitePalette.viewText.rgb else sitePalette.commonButtonSupportiveTextColor.rgb,
                                backgroundColor = if (player.count > 0) sitePalette.viewButtonBackground.rgb else sitePalette.textFieldBorderColorDisabled.rgb,
                                pointerCursor = player.count > 0,
                                width = 64.px,
                                height = 28.px,
                                onCLick = {
                                    if (player.count > 0) {
                                        userId = player.userId
                                        isViewClicked = true
                                    }
                                }
                            )
                        }
                    }
                    Divider()
                }
            }}
            else{
                var currentPage by remember { mutableStateOf(0) }
                val sessionsPerPage = 1
                val totalPages = (playerList.size + sessionsPerPage - 1) / sessionsPerPage
                val player = playerList[currentPage]
                key(player.userId) {
                    LaunchedEffect(isExpanding) {
                        if (isExpanding) {
                            isSummaryLoading = true
                            try {
                                val sessionUser = getSessionSummary(
                                    userID = player.userId,
                                    domainType = "soccer",
                                    language = "en",
                                    getAll = true,
                                    isPlayer = true,
                                    sessionType = "player assessment",
                                    organization = AppGlobal.userData.organization
                                )
                                sessionSummary.clear()
                                sessionSummary.addAll(sessionUser.data)
                            } finally {
                                isSummaryLoading = false
                            }
                        }
                    }
                    val selectedRating by remember { mutableStateOf(player.rating) }
                    Column(modifier = Modifier.fillMaxWidth().margin(top = 10.px)){
                        Column(modifier = Modifier.fillMaxWidth()
                            .onClick {
                                ctx.router.navigateTo("/player-details?userId=${player.userId}")
                            }
                        ) {

                            Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                                Column(modifier = Modifier.width(40.percent)) {
                                    FieldTitleTextNormalSimple(
                                        text = "Name",
                                        width = 100.percent,
                                        fontWeight = 500,
                                        fontSize = 15.px
                                    )
                                    FieldTitleTextNormalSimple(
                                        text = "Team",
                                        width = 100.percent,
                                        fontWeight = 500,
                                        fontSize = 12.px,
                                        color = sitePalette.infoIconColor.rgb
                                    )
                                }
                                Row(
                                    modifier = Modifier.width(60.percent)
                                        .cursor(Cursor.Pointer),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    if (player.imageUrl.isNotEmpty()) {
                                        Image(
                                            src = "${Res.Images.base_Image_Url}${player.imageUrl}",
                                            modifier = Modifier.size(30.px).margin(right = 5.px)
                                                .borderRadius(100.px).textAlign(TextAlign.Start)
                                        )
                                    } else {
                                        Image(
                                            src = Res.Images.userIcon,
                                            modifier = Modifier.size(30.px).margin(right = 7.px)
                                                .borderRadius(100.px)
                                        )
                                    }
                                    Column {
                                        FieldTitleTextNormalSimple(
                                            text = "${player.firstName} ${player.lastName}"
                                                .split(" ")
                                                .joinToString(" ") { word ->
                                                    word.lowercase()
                                                        .replaceFirstChar { it.titlecase() }
                                                },
                                            wordBreak = WordBreak.BreakAll,
                                            isClickable = true
                                        )
                                        FieldTitleTextNormalSimple(
                                            text = player.team.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() },
                                            fontSize = 11.px,
                                            color = sitePalette.infoIconColor.rgb,
                                            isClickable = true

                                        )
                                    }
                                }
                            }
                            Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                                FieldTitleTextNormalSimple(
                                    text = "Position:",
                                    fontSize = 15.px,
                                    fontWeight = 500,
                                    width = 40.percent
                                )
                                FieldTitleTextNormalSimple(
                                    text = player.position.ifEmpty { "-" },
                                    width = 60.percent,
                                    fontSize = 15.px,
                                    wordBreak = WordBreak.BreakAll,
                                    marginLeft = 60.px,
                                )
                            }
                            Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                                FieldTitleTextNormalSimple(
                                    text = "Age:",
                                    fontSize = 15.px,
                                    fontWeight = 500,
                                    width = 40.percent
                                )
                                FieldTitleTextNormalSimple(
                                    text = player.age.ifEmpty { "-" },
                                    width = 60.percent,
                                    fontSize = 15.px,
                                    wordBreak = WordBreak.BreakAll,
                                    marginLeft = 60.px,
                                )
                            }
                            Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                                FieldTitleTextNormalSimple(
                                    text = "Assessment:",
                                    fontSize = 15.px,
                                    fontWeight = 500,
                                    width = 40.percent
                                )
                                FieldTitleTextNormalSimple(
                                    text = if (player.count.toInt() == 0) "-" else player.count.toString(),
                                    width = 60.percent,
                                    fontSize = 15.px,
                                    wordBreak = WordBreak.BreakAll,
                                    marginLeft = 60.px,
                                )
                            }
                            Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                                LaunchedEffect(Unit) {
                                    initializeTooltips()

                                }
                                Row(
                                    modifier = Modifier.width(40.percent),
                                    verticalAlignment = Alignment.CenterVertically,
                                    horizontalArrangement = Arrangement.Center
                                ) {
                                    FieldTitleTextNormalSimple(
                                        text = "Avg. Rating",
                                        fontSize = 15.px,
                                        fontWeight = 500,
                                    )
                                    BSTooltip(
                                        text = "You can change the individual session rating in the player profile",
                                        direction = TooltipDirection.Top,
                                        content = {
                                            Box(
                                                modifier = Modifier
                                                    .width(17.px)
                                                    .height(17.px)
                                                    .backgroundColor(Colors.LightGray)
                                                    .cursor(Cursor.Pointer)
                                                    .borderRadius(100.px)
                                                    .margin(leftRight = 10.px),
                                                contentAlignment = Alignment.Center
                                            ) {
                                                FaInfo(
                                                    modifier = Modifier.color(Colors.White)
                                                        .cursor(Cursor.Pointer),
                                                    size = IconSize.XXS
                                                )
                                            }
                                        }
                                    )
                                }
                                Box(
                                    modifier = Modifier.width(60.percent).margin(left = 60.px),
                                ) {
                                    StarRating(
                                        rating = selectedRating,
                                        cursor = false,
                                        onRatingChanged = {
                                        }
                                    )
                                }
                            }
                        }
                        Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                            FieldTitleTextNormalSimple(
                                text = "Recommendations:",
                                fontSize = 15.px,
                                fontWeight = 500,
                                width = 40.percent
                            )
                            Box(
                                modifier = Modifier.width(60.percent),
                                contentAlignment = Alignment.Center
                            ) {
                                CommonButton(
                                    text = "View",
                                    textSpanColor = if (player.count > 0) sitePalette.viewText.rgb else sitePalette.commonButtonSupportiveTextColor.rgb,
                                    backgroundColor = if (player.count > 0) sitePalette.viewButtonBackground.rgb else sitePalette.textFieldBorderColorDisabled.rgb,
                                    pointerCursor = player.count > 0,
                                    width = 64.px,
                                    height = 28.px,
                                    onCLick = {
                                        if (player.count > 0) {
                                            userId = player.userId
                                            isViewClicked = true
                                        }
                                    }
                                )
                            }
                        }
//
                        if (totalPages > 1) {
                            Row(
                                modifier = Modifier
                                    .fillMaxWidth(),
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.End
                            ) {
                                CustomPagination(
                                    currentPage = currentPage,
                                    totalPages = totalPages,
                                    onPageChange = { newPage -> currentPage = newPage },
                                    sitePalette = sitePalette,
                                    leftRightPadding = 0.px,
                                    topBottomPadding = 0.px
                                )
                            }
                        }
                    }

                }

            }
        }
    }

}